'use client'

import React from 'react'
import independenceDayImage from '../assets/images/independence_day.gif';
import cad from '../assets/icons8-3d-printer-64.png';
import web from '../assets/icons8-internet-64.png';
import systemAdmin from '../assets/icons8-server-64.png';
import network from '../assets/icons8-networking-manager-64.png';
import cloudBackup from '../assets/icons8-cloud-storage-64.png';
import cloud from '../assets/icons8-cloud-64.png';

const perks = [
  {
    name: 'System Administration',
    imageSrc: systemAdmin,
    description:
      'Over two decades of hands-on experience deploying and maintaining Windows, macOS, and Linux environments... Expert in crafting advanced automation scripts with Python and Bash to streamline day-to-day operations.',
  },
  {
    name: 'Network Infrastructure & Security',
    imageSrc: network,
    description:
      'Expert in LAN, VLAN, QoS, firewall management, VPN, and routers/switches... Dedicated to configuring robust firewalls and security protocols to protect mission-critical data.',
  },
  {
    name: 'Cloud & Virtualization',
    imageSrc: cloud,
    description:
      'Experience with VMware, Hyper-V, Microsoft Azure, Google Cloud, Intune, Office 365... Proficient in designing scalable cloud architectures that optimize resource usage and reduce costs.',
  },
  {
    name: 'Web Development & Automation',
    imageSrc: web,
    description:
      'Specialized in the LAMP stack, MERN stack, AngularJS, Python, and automation scripting... Successfully built custom ERP solutions that boost productivity and streamline organizational workflows.',
  },
  {
    name: 'Data Backup & Recovery',
    imageSrc: cloudBackup,
    description:
      'Implement and manage backup strategies, both on-premise and cloud-based... Ensured 100% data protection with multi-layer redundancy and reliable disaster recovery protocols.',
  },
  {
    name: 'CAD Design & Support',
    imageSrc: cad,
    description:
      'Skilled in creating and modifying system designs with AutoCAD... Adept at collaborating with project managers and engineers to deliver precise, compliant drawings for large-scale builds.',
  },
]





const Expertise = () => {
  return (
    <div className="bg-gray-50 flex flex-col items-center justify-center py-20 mb-10">
      {/* Keep for accessibility, but hidden visually */}
      <h1 className="sr-only">Our perks</h1>
      
      {/* Bigger, centered heading */}
      <h1 className="mb-12 text-center text-4xl font-extrabold text-gray-900">
        Expertise
      </h1>

      <div className="max-w-4xl w-full px-4">
        <div className="mx-auto grid max-w-3xl grid-cols-1 gap-x-8 gap-y-12 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
          {perks.map((perk) => (
            <div key={perk.name} className="sm:flex">
              <div className="sm:shrink-0">
                <div className="flow-root">
                  <img alt="" src={perk.imageSrc} className="h-12" />
                </div>
              </div>
              <div className="mt-3 sm:ml-3 sm:mt-0">
                <h3 className="text-sm font-medium text-gray-900">{perk.name}</h3>
                <p className="mt-2 text-sm text-gray-500">{perk.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Expertise
